import {
  useSuspenseQuery,
  type UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useRouteContext } from "@tanstack/react-router";
import { fetchAuthenticatedData } from "@/queries/shared";
import type { GlobalStateModel } from "@/models";

type PreschoolLookupEntry = {
  PreschoolID: string;
  PreschoolName: string;
  PreschoolCDSCode: string;
};

export function usePreschoolNames(
  leaEsiidPaths: string[]
): UseSuspenseQueryResult<Record<string, string>> {
  const leaContext = useRouteContext({ from: "/$leaid" }) as GlobalStateModel;
  const sortedPaths = [...leaEsiidPaths].sort();

  return useSuspenseQuery<Record<string, string>>({
    queryKey: ["preschool-names", sortedPaths],
    queryFn: async () => {
      const results = await Promise.all(
        sortedPaths.map((esiidPath) =>
          fetchAuthenticatedData<PreschoolLookupEntry[]>(
            leaContext,
            `/json/entity/${esiidPath}/preschools`
          )
        )
      );

      const map: Record<string, string> = {};
      results.flat().forEach((p) => {
        map[p.PreschoolCDSCode] = p.PreschoolName;
      });
      return map;
    },
  });
}
